import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AlarmsService {

  state: TpromsState;
  private currentState; // NOSONAR
  stateValue;
  private guidStateSource = new BehaviorSubject<string>(''); // NOSONAR
  guidState = this.guidStateSource.asObservable();
  private nameStateSource = new BehaviorSubject<string>(''); // NOSONAR
  nameState = this.nameStateSource.asObservable();
  private IDStateSource = new BehaviorSubject<string>(''); // NOSONAR
  IDState = this.IDStateSource.asObservable();
  private roleStateSource = new BehaviorSubject<string>(''); // NOSONAR
  roleState = this.roleStateSource.asObservable();
  constants: Constants = new Constants();

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, X-Requested-With, Accept, Access-Control-Request-Method, Authorization'
    })
  };

  
  cont_type = 'Content-Type'
  apln_json = 'application/json'

  constructor(private readonly http: HttpClient) {
    this.state = {
      namc: '',
      WorkdayID: '',
      Name: '',
      Role: ''
    };
    this.currentState = new BehaviorSubject<TpromsState>(this.state);
    this.stateValue = this.currentState.asObservable();
  }

  getAlarmGroups(): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + '/alarms/api/v1/getalarmgroups', this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('Alarm Groups Data Success!')),
        catchError(this.handleError<any>('Alarm Groups Data Fails!'))
      );
  }

  getPeriods(): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + '/alarms/api/v1/getperiods', this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('Periods Data Success!')),
        catchError(this.handleError<any>('Periods Data Fails!'))
      );
  }

  getDomiciles(): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + '/alarms/api/v1/getdomiciles', this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('Domiciles Data Success!')),
        catchError(this.handleError<any>('Domiciles Data Fails!'))
      );
  }

  getAlarmsSummary(arrData: any): Observable<any> {
    const headers = new HttpHeaders().set(this.cont_type, this.apln_json);
    return this.http
      .post(this.constants.getApiBasePath() + '/alarms/api/v1/getalarmssummary', arrData, { headers, responseType: 'json' })
      .pipe(
        tap(_ => this.log('Alarms Summary Data Success!')),
        catchError(this.handleError<any>('Alarms Summary Data Fails!'))
      );
  }

  startAlarmsJob(arrData: any): Observable<any> {
    const headers = new HttpHeaders().set(this.cont_type, this.apln_json);
    return this.http
      .post(this.constants.getApiBasePath() + '/alarms/api/v1/runalarmjob', arrData, { headers, responseType: 'text' })
      .pipe(
        tap(_ => this.log('Alarms Job execution Success!')),
        catchError(this.handleError<any>('Alarms Job execution Failed!'))
      );
  }

  getAlarmStats(arrData: any): Observable<any> {
    const headers = new HttpHeaders().set(this.cont_type, this.apln_json);
    return this.http
      .post(this.constants.getApiBasePath() + '/alarms/api/v1/getalarmstats', arrData, { headers, responseType: 'json' })
      .pipe(
        tap(_ => this.log('Alarms Stats execution Success!')),
        catchError(this.handleError<any>('Alarms Stats execution Failed!'))
      );
  }

  getAlarmRoutes(arrData: any): Observable<any> {
    const headers = new HttpHeaders().set(this.cont_type, this.apln_json);
    return this.http
      .post(this.constants.getApiBasePath() + '/alarms/api/v1/getalarmroutes', arrData, { headers, responseType: 'json' })
      .pipe(
        tap(_ => this.log('Alarms Routes execution Success!')),
        catchError(this.handleError<any>('Alarms Routes execution Failed!'))
      );
  }

  getAlarmOutput(alarmId: any): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + '/alarms/api/v1/getalarmoutput/' + alarmId, this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('Alarm Output Success!')),
        catchError(this.handleError<any>('Alarm Output Fails!'))
      );
  }

  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      console.info(error);
      return of(result as T);
    };
  }

  private log(message: string) {
    console.info('Message: ' + message);
  }

  setGUIDState(name: string) {
    this.guidStateSource.next(name);
  }

  setNameState(name: string) {
    this.nameStateSource.next(name);
  }

  setIDState(ID: string) {
    this.IDStateSource.next(ID);
  }

  setroleState(role: string) {
    this.roleStateSource.next(role);
  }

  getNamc(): Observable<any> {
    return this.stateValue;
  }

  setNamc(namc: any) {
    this.currentState.next(namc);
  }

}

export interface TpromsState {

  namc: string;
  WorkdayID: string;
  Name: string;
  Role: string;
}